"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESuburbanEstimationCategory = exports.EEstimationTargets = void 0;
let EEstimationTargets = exports.EEstimationTargets = /*#__PURE__*/function (EEstimationTargets) {
  EEstimationTargets[EEstimationTargets["flat"] = 0] = "flat";
  EEstimationTargets[EEstimationTargets["house"] = 1] = "house";
  EEstimationTargets[EEstimationTargets["land"] = 2] = "land";
  EEstimationTargets[EEstimationTargets["newbuilding"] = 3] = "newbuilding";
  return EEstimationTargets;
}({});
let ESuburbanEstimationCategory = exports.ESuburbanEstimationCategory = /*#__PURE__*/function (ESuburbanEstimationCategory) {
  ESuburbanEstimationCategory["LandSale"] = "landSale";
  ESuburbanEstimationCategory["HouseSale"] = "houseSale";
  return ESuburbanEstimationCategory;
}({});